/**
 * Defense-in-depth scrub for user-supplied standing guidance (custom and
 * communications instructions). The system prompt already treats the wrapped
 * instruction blocks as untrusted, so this is belt-and-suspenders:
 * - Angle brackets — can't open or close a tag inside the wrapped block.
 * - ASCII control characters — never legitimate in typed preferences.
 * - Zero-width and bidi-override Unicode — invisible to the user in the
 *   input but still reach the model, the classic way to smuggle hidden
 *   text past a human reviewer.
 */
export const sanitizeInstructionsInput = (value: string): string =>
  value
    .replace(/[<>]/g, "")
    // biome-ignore lint/suspicious/noControlCharactersInRegex: stripping these is the point
    .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, "")
    // U+200B-U+200F: ZWSP, ZWNJ, ZWJ, LRM, RLM.
    // U+202A-U+202E: LRE, RLE, PDF, LRO, RLO (bidi overrides).
    // U+2060-U+2069: word joiner + isolate/invisible operators.
    // U+FEFF: BOM / zero-width no-break space.
    .replace(/[​-‏‪-‮⁠-⁩﻿]/g, "");
